import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { DesignerDrawer } from '../../DesignerDrawer/DesignerDrawer'
import { UploadsTabProvider, useUploadsTab } from '../UploadsTabContext'
import { DefaultPanel } from './DefaultPanel'
import { UploadsPanel } from './UploadsPanel'
import { StockPhotosPanel } from './StockPhotosPanel'
import { StockVideosPanel } from './StockVideosPanel'
import { BrandKitPanel } from './BrandKitPanel'
import { ShapesPanel } from './ShapesPanel'
import { MasksPanel } from './MasksPanel'
import { IconsPanel } from './IconsPanel'

interface Props {
  title?: string
  onBack?: () => void
}

export const InnerDrawer = observer(() => {
  const { panel, panelProps } = useUploadsTab()

  if (panel === 'uploads') return <UploadsPanel {...panelProps} />
  if (panel === 'photos') return <StockPhotosPanel {...panelProps} />
  if (panel === 'videos') return <StockVideosPanel {...panelProps} />
  if (panel === 'brandKit') return <BrandKitPanel {...panelProps} />
  if (panel === 'shapes') return <ShapesPanel {...panelProps} />
  if (panel === 'masks') return <MasksPanel {...panelProps} />
  if (panel === 'icons') return <IconsPanel {...panelProps} />

  return <DefaultPanel />
})

export const titles = {
  default: 'Insert',
  uploads: 'Uploads',
  videos: 'Stock Videos',
  photos: 'Stock Photos',
  brandKit: 'Brand Kit',
  shapes: 'Shapes',
  masks: 'Frames',
  icons: 'Icons',
}

const UploadsDrawerWrapper = observer((props: DrawerProps) => {
  const { panel, closePanel, panelProps } = useUploadsTab()
  const title = 'title' in panelProps ? panelProps.title : titles[panel]
  const handleOnBack = panel === 'default' ? undefined : closePanel

  return (
    <DesignerDrawer title={title} onBack={handleOnBack} enableSnap {...props}>
      <InnerDrawer />
    </DesignerDrawer>
  )
})

const UploadsDrawerContainer = (props: DrawerProps & Props) => {
  return (
    <UploadsTabProvider>
      <UploadsDrawerWrapper {...props} />
    </UploadsTabProvider>
  )
}

export { UploadsDrawerContainer as UploadsDrawer }
